import {
  Document,
  ImageRun,
  Packer,
  Paragraph,
  TextRun,
  PageNumber,
  Footer,
} from "docx";
import PptxGenJS from "pptxgenjs";
import { saveAs } from "file-saver";
import { Buffer } from "buffer";

export const generateDocFile = (base64Images, sensorsList) => {
  const paragraphArray = [];
  for (let i = 0; i < base64Images.exportHighChart.length; i++) {
    const result = base64Images.exportHighChart[i];
    const base64Img = result.base64Image;
    const sensorObj = sensorsList.filter(
      (sensor) => sensor.value === result.sensorId
    );
    const chartName = sensorObj[0].label;
    paragraphArray.push(
      new Paragraph({
        children: [
          new TextRun({ text: chartName, break: 2 }),
          new ImageRun({
            data: Buffer.from(base64Img, "base64"),
            transformation: {
              width: 600,
              height: 400,
            },
          }),
        ],
      })
    );
  }

  let today = new Date();
  let now = today.toLocaleDateString("en-US");

  return new Document({
    sections: [
      {
        footers: {
          default: new Footer({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    children: ["Page #: ", PageNumber.CURRENT, "  "],
                  }),
                  new TextRun("Export Date: " + now),
                ],
              }),
            ],
          }),
        },
        children: paragraphArray,
      },
    ],
  });
};

export const generatePowerpointFile = (base64Images, sensorsList) => {
  const pptx = new PptxGenJS();
  for (let i = 0; i < base64Images.exportHighChart.length; i++) {
    const result = base64Images.exportHighChart[i];
    const base64Img = result.base64Image;
    const sensorObj = sensorsList.filter(
      (sensor) => sensor.value === result.sensorId
    );
    const chartName = sensorObj[0].label;

    let today = new Date();
    let now = today.toLocaleDateString("en-US");

    pptx.defineSlideMaster({
      title: "MASTER_SLIDE",
      bkgd: "FFFFFF",
      objects: [{ text: { text: now, options: { x: 8.5, y: 0.3 } } }],
      slideNumber: { x: "95%", y: "90%" },
    });

    let slide = pptx.addSlide({ masterName: "MASTER_SLIDE" });

    slide.addText(chartName, { x: 0.1, y: 0.2 });

    slide.addImage({
      data: "image/png;base64," + base64Img,
      x: 1,
      y: 0.5,
      w: 8,
      h: 5,
    });
  }
  return pptx;
};

export const exportGraph = (name, exportFileType, file) => {
  const today = new Date();
  const yy = today.getFullYear().toString().substring(2);
  let mm = today.getMonth() + 1; // Months start at 0!
  let dd = today.getDate();
  let exportmm = "";
  let exportdd = "";

  dd < 10 ? (exportdd = "0" + dd) : (exportdd = "" + dd);
  mm < 10 ? (exportmm = "0" + mm) : (exportmm = "" + dd);

  const exportDate = exportdd + exportmm + yy;

  const stockpileName = name?.toUpperCase();
  let exportStockpile =
    stockpileName === ""
      ? "SP"
      : stockpileName.includes("SP")
      ? stockpileName
      : "SP" + stockpileName;

  let version = localStorage.getItem(exportStockpile);

  if (version) {
    localStorage.setItem(exportStockpile, (Number(version) + 1).toString());
  } else {
    localStorage.setItem(exportStockpile, "2");
    version = "1";
  }

  let exportName = exportStockpile + "_" + exportDate + "_" + version;

  if (exportFileType === "docx") {
    Packer.toBlob(file).then((blob) => {
      saveAs(blob, exportName + ".docx");
    });
  } else {
    file.writeFile({ fileName: exportName });
  }
};
